import { render, staticRenderFns } from "./agentLoadingPlaceholder.vue?vue&type=template&id=eff490c2&scoped=true&"
import script from "./agentLoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./agentLoadingPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./agentLoadingPlaceholder.vue?vue&type=style&index=0&id=eff490c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff490c2",
  null
  
)

export default component.exports